module.exports = __webpack_public_path__ + "static/media/S-4.583283a4.mp3";